export default "__VITE_ASSET__Btd4J$AZ__"